module.exports = __webpack_public_path__ + "img/borrower_benefit_hero.1148a7e9.jpg";